'use strict';

export default class ApiEndpoint {
  constructor(session) {
    this._session = session;
  }

  set session(session) {
    this.session = session;
  }

  get session() {
    return this._session;
  }

  execute(callback = undefined, session = undefined) {
    console.warn('Execute function should be overridden.');
  }
}
